/**
 * @generated SignedSource<<9b43f536c73d1d7e997c56763ba90f74>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type sectionEditorPicksQueue$data = ReadonlyArray<{
  readonly node: {
    readonly entityId?: string;
    readonly " $fragmentSpreads": FragmentRefs<"sectionEditorPicksContentItemContent">;
  };
  readonly " $fragmentType": "sectionEditorPicksQueue";
}>;
export type sectionEditorPicksQueue$key = ReadonlyArray<{
  readonly " $data"?: sectionEditorPicksQueue$data;
  readonly " $fragmentSpreads": FragmentRefs<"sectionEditorPicksQueue">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "sectionEditorPicksQueue",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityId",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "sectionEditorPicksContentItemContent"
            }
          ],
          "type": "Content",
          "abstractKey": "__isContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemsEdge",
  "abstractKey": null
};

(node as any).hash = "fd3863f7e202653286df5a3f7e5d6a4c";

export default node;
